import service from './request.js';
import BASE_URL from './api.js';
import router from '../router'

// 轮播图

export function getSliders() {
    return service.get(`${BASE_URL}/sliders?platform=PC`)
}
// 课程分类-全部
export function getCategory(id) {
    return service.get(`${BASE_URL}/course/category?cate_id=` + id)
}
// 课程列表
export function getCategoryList(parmas) {
    return service.get(`${BASE_URL}/courses?category_id=${parmas.id}&page=${parmas.page}&per_page=${parmas.per_page}`)
}
// 课程详情
export function getCourseDetail(id) {
    return service.get(`${BASE_URL}/course/${id}`)
}
// 课程收藏与取消
export function courseCollect(id) {
    return service.get(`${BASE_URL}/course/${id}/like`)
}
// 视频播放  
export function getVideoPlayer(id) {
    return service.get(`${BASE_URL}/video/${id}`)
}
// 播放凭证   
export function getPlayAuth(id) {
    return service.get(`${BASE_URL}/video/${id}/playAuth`)
}
// 课程视频的观看时长提交
export function postWatchTime(id,watchTimeData) {
    return service.post(`${BASE_URL}/video/${id}/watch_at`,watchTimeData)
}
// 课程的附件下载地址
export function getDocDownload(id) {
    return service.get(`${BASE_URL}/course/attach/${id}/download`)
}

// 我的课程
export function getMyCourse(parmas) {
    return service.get(`${BASE_URL}/member/courses?per_page=${parmas.per_page}&page=${parmas.page}`)
}
// 收藏课程
export function getLikeCourse(parmas) {
    return service.get(`${BASE_URL}/member/like?per_page=${parmas.per_page}&page=${parmas.page}`)
}
// 课程问答 /wenda
export function postWenda(data){
    return service.post(`${BASE_URL}/wenda`,data)
}
// 问答列表
export function getWendaList(parmas) {
    return service.get(`${BASE_URL}/wenda?course id=${parmas.id}&video_id=${parmas.video_id}?per_page=100&page=1`)
}

// 我的订单
export function getOrder(parmas) {
    return service.get(`${BASE_URL}/order?per_page=${parmas.per_page}&page=${parmas.page}`)
}
